<!-- 订单详情 -->
<template>
    <div class="home">
        <van-nav-bar
            :title="$t('OrderDetail.title')"
            fixed
        >
        </van-nav-bar>
        <div class="detail_top" v-if="orderDetail">            
            <div class="row1">
                <div class="top_success">
                    <!-- <van-icon name="checked" color="#FFC813" size="40px"/> -->
                    <van-icon name="./static/img/ok.png"  size='25px' class="okIcon"/>
                    <div style="width: auto;height: 40px;line-height: 40px;float: right;font-size: 18px">{{$t('OrderDetail.success')}}</div>
                </div>
            </div>
            <!-- 點單用戶信息 --> 
            <div class="orderUser" v-if="orderDetail.order_address">
                <div class="infoItem">
                    <div class="info_left">{{$t('InputInfo.name')}}</div>
                    <div class="info_right">{{orderDetail.order_address.name}}</div>
                </div>
                <div class="infoItem">
                    <div class="info_left">{{$t('InputInfo.phone')}}</div>
                    <div class="info_right">{{orderDetail.order_address.phone}}</div>
                </div> 
                <div class="infoItem" v-if="img">
                    <div class="info_left">{{$t('InputInfo.paymentVoucher')}}</div>
                    <div class="info_right">
                        <van-image width="55" fit="contain" height="55"
                            @click="showImg = true"
                            :src="img"
                        />
                    </div>
                </div>
            </div>

            <div class="info_ticket">{{$t('OrderDetail.ticketTip')}}</div>
            <div class="top_ticket_title">{{$t('OrderDetail.ticket')}}</div>
            <div class="top_ticket">{{orderDetail.ticket}}</div>
            <div class="top_price">{{sessionStorage.getItem('currency')}}{{orderDetail.final_price}}</div>
            <div class="top_price">
                <span v-if="orderDetail.status==2">{{$t('OrderDetail.pay')}}</span>
                <span v-else>{{$t('OrderDetail.unpaid')}}</span>
            </div>
        </div>
        
        <div class="orderDishes" v-if="orderDetail">
            <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
            <template v-for="(dish,index) in orderDetail.package">
                <div class="dishItem">
                    <div class="dishDetail">
                        <div class="dish_name noExceed">{{dish.menu_name}}</div>
                        <div class="dish_num price">X{{dish.number}}</div>
                        <div class="dish_price noExceed tr">{{sessionStorage.getItem('currency')}}{{dish.price}}</div>
                        <div v-if="dish.category=='m'" class="dish_des noExceed">
                            <template v-for="val in dish.tags_name">
                                {{val}}
                            </template>
                            {{dish.remark}}
                        </div>
                    </div>
                    <template v-for="(son,key) in dish.details" >
                        <div class="dishDetail son">
                            <div class="dish_name noExceed">{{son.menus_name}}</div>
                            <div class="dish_num"></div>
                            <div class="dish_price noExceed">
                                
                            </div>
                            <div class="dish_des noExceed">
                                <template v-for="val in son.tags_name">
                                    {{val}}
                                </template>
                                {{son.remark}}
                            </div>
                        </div>
                    </template>
                    <!-- 下单时间 -->
                    <div class="infoItem">
                        <div class="info_left">{{$t('OrderDetail.time')}}</div>
                        <div class="info_right">{{dish.created_at}}</div>
                    </div>
                    <div class="menuIconGroup">
                        <div v-if="dish.status==0" class="type_icon">
                            <van-icon name="./static/img/cook_prepare_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status0')}}</span>
                        </div>
                        <div v-else-if="dish.status==1" class="type_icon">
                            <van-icon name="./static/img/cook_cooking_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status1')}}</span>
                        </div>
                        <div v-else-if="dish.status==2" class="type_icon">
                            <van-icon name="./static/img/cook_compele_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status2')}}</span>
                        </div>
                        <div v-else-if="dish.status==3" class="type_icon">
                            <van-icon name="./static/img/cook_finsh_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status3')}}</span>
                        </div>
                        <div v-else-if="dish.status==5" class="type_icon">
                            <van-icon name="./static/img/cook_finsh_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status5')}}</span>
                        </div>
                        <div v-else-if="dish.status==4" class="type_icon">
                            <van-icon name="./static/img/cook_finsh_small.png" size="30px"/> 
                            <span>{{$t('OrderDetail.status4')}}</span>
                        </div>
                    </div>
                </div>
                <div style="height: 1px;width: 100%;background-color: #F3F5F7;"></div>
            </template>
        </div>
        <div class="orderInfo">
            <div class="infoItem">
                <div class="info_left">{{$t('OrderDetail.addressMoney')}}</div>
                <div class="info_right">{{sessionStorage.getItem('currency')}}{{orderDetail.additional_price}}</div>
            </div>
            <div class="infoItem">
                <div class="info_left">{{$t('OrderDetail.time')}}</div>
                <div class="info_right">{{orderDetail.created_at}}</div>
            </div>
            <div class="infoItem">
                <div class="info_left">{{$t('OrderDetail.orderNum')}}</div>
                <div class="info_right">{{orderDetail.order}}</div>
            </div>
        </div>

        <!-- <div style="height: 60px;"></div> -->
        <div class="shopBottom">
            <van-button class="certainBtn" round @click="continueOrder()">{{$t('OrderDetail.againOrder')}}</van-button>
        </div>
        <van-popup v-model="showImg" v-if="img">
            <van-image  fit="contain" 
            :src="img"/>
        </van-popup>
    </div>
</template>

<script>
export default {
    data () {
        return {
            orderDetail:{},
            showImg: false,
            img:''
        };
    },
    created(){
        // if(localStorage.onlyCode){
        //     if(localStorage.onlyCode==localStorage.successCode && localStorage.takeOrderId!==undefined && localStorage.isPay === 'true'){
        //         this.getOrderDetail();
        //     }else{
        //         this.continueOrder();
        //     }
        // }else{
        //     this.continueOrder();
        // }
        if(!sessionStorage.currency){
            this.getShopInfo();
        }
        if(localStorage.successCode){
            if(localStorage.successCode && localStorage.takeOrderId!==undefined && localStorage.isPay === 'true'){
                this.getOrderDetail();
            }else{
                this.continueOrder();
            }
        }else{
            this.continueOrder();
        }
    },
    methods: {
        //获取店铺信息
        getShopInfo(){
            this.$axios({
                method:'get',
                headers: {
                    'code':sessionStorage.code,
                },
                url:this.$build+'/api/store/'+sessionStorage.storeId+'/customerShow',
            }).then(res =>{
                console.log(res);
                if(res.data.status==200){
                    // this.shopInfos=res.data.data;
                    sessionStorage.setItem('currency',res.data.data.currency.unit);
                    sessionStorage.setItem('is_quick',res.data.data.is_quick);
                }else{
                    this.$toast.allowMultiple();
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err =>{
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
        // 获取订单详情
        getOrderDetail(){
            this.$axios({
                method: 'PUT',
                url: this.$build+'/api/order/'+this.$route.params.id+'/takeIndex',
            }).then(res => {
                if(res.data.status==200){
                    console.log(res)
                    this.orderDetail=res.data.data;
                    if(res.data.data.certificates[0]){
                        this.img = res.data.data.certificates[0].image.path
                    }
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
        // 在下一单，重新获取唯一标识
        continueOrder(){
            // 清空附加费地址、索引与是否点击提交的判断
            sessionStorage.removeItem("submitOrder")
            sessionStorage.removeItem("additional")
            sessionStorage.removeItem("additionalIndex")
            this.$axios({
                method:'get',
                url:this.$build+'/api/shopcart/create',
            }).then(res=>{
                console.log(res)
                if(res.data.status==200){
                    localStorage.setItem('onlyCode',res.data.code)
                    var vm = this;
                    // 跳转到菜品页面
                    setTimeout(()=>{
                        vm.$router.push('/TakeDishes')
                    },500)
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
    }
}

</script>
<style scoped>
    /deep/ .van-image {
        /* font-size: 0; */
        vertical-align: middle;
        max-width: 600px;
        max-height: 600px;
    }
    /deep/ .van-nav-bar .van-icon{
        font-size: 26px;
        color: #fff;
    }
    /deep/ .van-field__body>input{
        text-align: right;
    }
    .okIcon{
        vertical-align: middle;
    }
    .home{
        width: 100%;
        height: 100vh;
        background-color: #fff;
    }
    .detail_top{
        padding-top: 46px;
        width: 100%;
        /*height: 126px;*/
        padding-bottom: 20px;
        background-color: #F3F5F7;
        /*display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;*/
    }
    .top_success{
        width: auto;
        height:40px;
        line-height: 40px;
        padding-right: 20px;
    }
    .top_sit{
        height: 35px;
        line-height: 35px;
        font-size: 18px;
       padding-left: 10px;
    }
    .top_ticket_title{
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-weight: bold;
        font-size: 24px;
    }
    .top_ticket{
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-weight: bold;
        font-size: 4.5rem;
        margin-bottom: 40px;
    }
    .top_price{
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        font-size: 22px;
        margin-top: 5px;
    }
    .dishDetail .price{
        text-align: left;
        color: #999;
    }
    .orderDishes{
        width: 100%;
        min-height: 50px;
    }
    .dishItem{
        width: 90%;
        margin-left: 5%;
        min-height: 35px;
        position: relative;
    }
    .dish_name{
        width: 60%;
        height: 35px;
        line-height: 35px;
        float: left;
    }
    .dish_num{
        width: 15%;
        height: 35px;
        line-height: 35px;
        float: left;
        color: #000;
    }
    .dish_price{
        width: 25%;
        height: 35px;
        line-height: 35px;
        color: #000;
        float: left;
        text-align: right;
    }
    .dishDetail .price{
        text-align: left;
        color: #000;
    }
    .dish_des{
        width: 100%;
        height: 20px;
        color: #999;
        clear: both;
        font-size: 14px;
    }
    .leftdot{
        position: absolute;
        width: 6px;
        height: 6px;
        left: -3.5%;
        top: 15px;
        background: linear-gradient(90deg, #FFC914 , #FFC813);
        border-radius: 50%;
    }
    .totalPrice{
        width: 100%;
        height: 20px;
        line-height:20px;
        font-size: 16px;
        text-align: right; 
    }
    .son>div{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
    }
    @media screen and (min-width: 800px) {
      .shopBottom {
        width:800px
      }
    }
    @media screen and (max-width: 800px) {
      .shopBottom {
        width: 100%;
      }
    }
    .shopBottom{
        position: fixed;
        bottom: 0;
        height: 60px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #ccc;
    }
    .cancelBtn{
        width: 30%;
        top:8px;
        left: 5%;
        background:#2f75f4;
        color: #fff;
        font-weight: bold;
        font-size: 16px;
    }
    .certainBtn{
        top:8px;
        width: 95%;
        background:#2f75f4;
        color: #fff;
        font-weight: bold;
        font-size: 16px;
        margin:0 auto;
    }
    .orderUser {
        width:90%;
        margin-left: 5%;
        height: 60px;
        padding: 5px 0 0 0;
        margin-bottom: 30px;
    }
    .orderInfo{
        width:90%;
        margin-left: 5%;
        height: 60px;
        padding: 5px 0 100px 0;
    }
    .infoItem{
        width: 100%;
        height: 25px;
        font-size: 14px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: space-between;
    }
    .info_left{
        flex: auto;
        text-align: left;
        height: 25px;
        line-height: 25px; 
    }  
    .info_right{
        flex: auto;
        text-align: right;
        height: 25px;
        line-height: 25px;
    }
    .info_ticket{
        width: 90%;
        margin-left: 5%;
        height: 60px;
        padding-top: 10px;
        text-align: center;
        font-weight: bold;
        /*color: red;*/
        margin-bottom: 10px;
    }
    .menuIconGroup{
        height: 35px;
    }
    .type_icon{
        width: 50%;
        height: 35px;
        line-height: 35px;
        float: left;
        display: flex;
        display: -webkit-flex;
        align-items: center;
    }
    .type_icon>span{
        font-size: 14px;
        text-indent: 10px;
    }
    .row1{
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
    }
</style>


// WEBPACK FOOTER //
// src/takeAway/TakeOrderDetail.vue